import * as React from 'react';
import { SendToPipefyConfirmDispatchProps, SendToPipefyConfirmStateProps } from '../../types/containers';

const SendToPipefyConfirmView: React.FC<SendToPipefyConfirmStateProps & SendToPipefyConfirmDispatchProps>
= ({ bankName, onCancel, onConfirm }) => (
    <div className="col-12 p-0">
        <div className="text-justify pb-4">
            {`¿Confirmas el envío a Pipefy para el banco ${bankName}?`}
        </div>
        <div className="pt-3 pb-2 px-0 text-right border-top">
            <a className="h-auto btn btn-link border-0 btn-form text-secondary-lighten-5 py-0"
               onClick={onCancel}>Cancelar</a>
            <a className="h-auto btn btn-link border-0 btn-form text-primary py-0 pr-0"
               onClick={onConfirm}>Confirmar</a>
        </div>
    </div>
);

export default SendToPipefyConfirmView;
